import { render } from "./HeaderInfoBox.vue?vue&type=template&id=5c6d2945&scoped=true"
import script from "./HeaderInfoBox.vue?vue&type=script&lang=js"
export * from "./HeaderInfoBox.vue?vue&type=script&lang=js"

import "./HeaderInfoBox.vue?vue&type=style&index=0&id=5c6d2945&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c6d2945"]])

export default __exports__